import { defineStore } from 'pinia';

import {
  CompanyDetailResponse,
  CompanyRepository,
} from '@/repositories/generated';
import { toPostalCodeWithHyphen } from '@/utils';
import { CompanyEditForm } from '@/validations/company';

type TEditCompanyState = {
  form: CompanyEditForm | undefined;
  initData: CompanyDetailResponse | undefined;
};

export const useEditCompanyStore = defineStore('editCompany', {
  state: (): TEditCompanyState => ({
    form: undefined,
    initData: undefined,
  }),
  actions: {
    async editCompany() {
      const {
        form,
        initData,
      } = this;

      if (!(form && initData)) return;

      await CompanyRepository.edit({
        id: initData.id,
        requestBody: {
          ...form,
          externalId: form.externalCompanyId ?? '', // TODO: 企業編集で外部企業IDをnullableにする際に修正する(REM-2191)
          name: form.companyName,
          postalCode: toPostalCodeWithHyphen(form.postalCode) ?? '',
          startsAt: form.startsAt.toISOString(),
          endsAt: form.endsAt?.toISOString(),
          staticQrCompanyId: form.staticQrCompanyId || undefined, // staticQrCompanyIdが空文字の場合にundefinedにしたいため||を使用
          bankAccount: form.bankAccount && {
            bankCode: form.bankAccount.bankCode,
            bankBranchCode: form.bankAccount.bankBranchCode,
            bankAccountType: form.bankAccount.bankAccountType,
            bankAccountNumber: form.bankAccount.bankAccountNumber,
            bankAccountHolder: form.bankAccount.bankAccountHolder,
          },
          terminalOptionalNarrowedFlg: form.terminalOptionalNarrowedFlg,
          lastUpdatedAt: form.lastUpdatedAt,
          companyUpdateSmartCode: form.companyUpdateSmartCodeInfo ?? undefined,
        },
      });
    },
    async setInitData(id: string) {
      this.$reset();

      const response = await CompanyRepository.detail({ id });
      this.initData = response;
    },
    setUiForm(form: CompanyEditForm) {
      this.form = {
        ...form,
        bankAccount: form.bankAccount && {
          ...form.bankAccount,
        },
        companyUpdateSmartCodeInfo: form.companyUpdateSmartCodeInfo && {
          ...form.companyUpdateSmartCodeInfo,
        },
      };
    },
    $resetForm() {
      this.form = undefined;
    },
  },
});
